import React ,{useEffect} from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation, Pagination, Autoplay } from "swiper/modules";
import Img2 from "./img/img_bg/webp/US-TEXTIL2.webp";
import Img1 from "./img/img_bg/webp/feshotel.webp";
import Img3 from "./img/img_bg/webp/US-PRINT_ECOLE.webp";

const carouselItems = [
  {
    img: Img1,
    alt: "Plafond tendu brillant avec éclairage LED intégré – design intérieur haut de gamme UNIK SYSTEM",
    subtitle: (
    <>
      <span className="subtitle-us">US</span> STRETCH
    </>
  ),

    title: "Plafonds & Murs Tendus Design Moderne",
    text: "Une solution haut de gamme offrant une finition parfaitement lisse, durable et compatible avec LED, Lightbox et impressions HD."
  },
  {
    img: Img2,
    alt:"Mur architectonique en toile tendue – design contemporain intérieur – architecture textile UNIK SYSTEM",
    subtitle: (
    <>
      <span className="subtitle-us">US</span> TEXTIL
    </>
  ),
    
    title: "Éclairage Intégré & Toiles Translucides",
    text: "Créez des ambiances lumineuses uniques grâce a la toile tendue rétroéclairée et aux solutions textiles premium."
  },
  {
    img: Img3,
    alt: "Plafond tendu artistique imprimé – solution architecture textile intérieure UNIK SYSTEM",
    subtitle: (
    <>
      <span className="subtitle-us">US</span> PRINT
    </>
  ),
    title: "Impression Haute Définition",
    text: "Personnalisez votre plafond ou mur avec des impressions HD : ciel, textures, branding, motifs décoratifs."
  }
];

const HeaderCarousel = () => {
  useEffect(() => {
      AOS.init({
        duration: 1500,
        once: true,
      });
    }, []);
  return (
    <div className="container-fluid p-0" id="section1">

      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        loop={true}
        autoplay={{
          delay: 8000,
          disableOnInteraction: false,
        }}
      >
        {carouselItems.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="position-relative">

              {/* IMAGE */}
              <img className="w-100 hero-img" src={item.img} alt={item.alt} loading="lazy"/>

              {/* OVERLAY */}
              <div className="hero-overlay d-flex align-items-center">
                <div className="container">
                  <div  className="col-12 col-lg-8">

                    <h5 className="text-uppercase mb-2 text-white fw-bold tracking-in">
                      {item.subtitle}
                    </h5>

                    <h1 className="display-3 fw-bold text-white mb-4 slide-down" >
                      {item.title}
                    </h1>

                    <p className="fs-5 text-white mb-4 slide-up">
                      {item.text}
                    </p>

                    <a href="#titre-gallry" className="btn py-md-3 px-md-5 me-3 slide-left" id="pmt-link">
                      Voir nos réalisations
                    </a>

                    <a href="/devis" className="btn py-md-3 px-md-5 slide-left" id="pmt-link2">
                      Demander un devis
                    </a>

                  </div>
                </div>
              </div>

            </div>
          </SwiperSlide>
        ))}
      </Swiper>

    </div>
  );
};

export default HeaderCarousel;

